// imports
import Component from 'minsky-kit/js/components/Component';
import DayTab from './DayTab';

// private statics
const VERSION = '1.0.0';

// class definition
export default class DayTabs extends Component {
    // constructor
    constructor (args = {}, objectName = 'DayTabs') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        this.tabs = args.tabs;
        this.activeTab = false;
        this.tabDirectory = {};

        // prep tabs html
        this.prep();

        // set intial active
        this.activate(this.tabs[0].content.dataset.tabId, true);
    }

    // methods
    prep () {
        for (let i = 0; i < this.tabs.length; i++) {
            const tab = this.tabs[i];
            // console.log(tab.trigger);
            tab.trigger.addEventListener('click', this.blm.add('onTriggerClick', onTriggerClick));
            tab['component'] = new DayTab({ $el: tab.content, id: tab.content.dataset.tabId });
            tab.component.hide();
            this.tabDirectory[tab.content.dataset.tabId] = tab;
        }
    }

    activate (id, initial = false) {
        // check if aldready active -> do nothing
        if (this.activeTab === this.tabDirectory[id]) return;
        // deactivate current tab
        if (this.activeTab) {
            this.activeTab.component.hide();
            this.activeTab.trigger.classList.remove('tabs__trigger--active');
        }

        // show tab
        this.activeTab = this.tabDirectory[id];
        this.activeTab.component.show();
        // add active class on trigger
        this.activeTab.trigger.classList.add('tabs__trigger--active');

        // scrollTo
        if (!initial) {
            gsap.to(window, { duration: 0.5, scrollTo: this.el.querySelector('.festival__content') });
        }
        if (!initial) {
            this.dispatch('tabChange', { tabId: id });
        }
    }

    get (id) {
        return this.tabDirectory[id];
    }

    destroy () {
        // super destroy
        this.tabs.forEach((tab) => {
            tab.contentParent.appendChild(tab.component.el);
            tab.trigger.parentNode.removeChild(tab.trigger);
            tab.component.destroy();
        });

        super.destroy();
    }

    // getters & setters
    static get version () { return VERSION; }
}

// Utils

// Event handlers
function onTriggerClick (e) {
    e.preventDefault();
    this.activate(e.currentTarget.dataset.tabId);
}
